<ng-container *transloco="let t">
    <ng-container *ngIf="groupData">
        <div class="bh-line-elements bh-align-items-center">
            <ng-container *ngIf="settings && settings.mode === 'dates'">
                <bazis-tabs
                    class="bh-hide-xl-down bh-margin-bottom-3x"
                    style="--tabs-gap: 16px; --tab-margin-end: 0"
                    [tabList]="monthsTabs"
                    [selectedTab]="selectedMonth"
                    (selectedTabChange)="onSelectedMonthChanged($event)"
                    [needScroll]="false"
                ></bazis-tabs>

                <bazis-select
                    [formControl]="selectCtrl"
                    [options]="yearsList"
                    [multiple]="false"
                ></bazis-select>

                <bazis-select
                    class="bh-hide-xl-up"
                    [formControl]="selectedMonthCtrl"
                    [options]="monthsList"
                    [multiple]="false"
                ></bazis-select>
            </ng-container>

            <ng-container *ngIf="settings && settings.mode === 'months'">
                <bazis-tabs
                    class="bh-hide-xl-down bh-margin-bottom-3x"
                    style="--tabs-gap: 16px; --tab-margin-end: 0"
                    [tabList]="yearsTabs"
                    [selectedTab]="selectedYear"
                    (selectedTabChange)="onSelectedYearChanged($event)"
                    [needScroll]="false"
                ></bazis-tabs>

                <bazis-select
                    class="bh-hide-xl-up bh-popper-z-index"
                    [formControl]="selectedYearCtrl"
                    [options]="yearsList"
                    [multiple]="false"
                ></bazis-select>
            </ng-container>
        </div>

        <ng-container *ngIf="chart">
            <div
                [style.padding-top.px]="20"
                [chart]="chart"
            ></div>
        </ng-container>
    </ng-container>

    <ng-template #empty>
        <div> {{ t('analytics.groups.empty') }}</div>
    </ng-template>

    <ng-container
        *ngIf="{
            change: changes$ | async,
            selectedMonthChanges: selectedMonthChanges$ | async,
            selectedYearChanges: selectedYearChanges$ | async,
        }"
    ></ng-container>
</ng-container>
